
// do query
export const START_LOAD_QUESTIONNAIRE_RESULTS = 'START_LOAD_QUESTIONNAIRE_RESULTS';
export const LOAD_QUESTIONNAIRE_RESULTS_SUCCESS = 'LOAD_QUESTIONNAIRE_RESULTS_SUCCESS';
export const LOAD_QUESTIONNAIRE_RESULTS_FAILURE = 'LOAD_QUESTIONNAIRE_RESULTS_FAILURE';
export const INIT_LOAD_QUESTIONNAIRE_RESULTS_ACTION_STATUS = 'INIT_LOAD_QUESTIONNAIRE_RESULTS_ACTION_STATUS';


